module.exports = __webpack_public_path__ + "static/talk-6-a4bf37ab1e81a44b18f3795c22f91a4c.png";